import { apiClient } from './api'

export interface AssistantTurn { role: 'user' | 'assistant'; content: string }
export interface AssistantReply { reply: string; tools_used: string[]; sources: string[] }

export const workspaceAssistantService = {
  ask: (messages: AssistantTurn[]) =>
    apiClient.post<AssistantReply>('/api/v1/ai/assistant', { messages }).then((r) => r.data),
}
